import { VazeciProcenatZaradeUpdateComponent } from './vazeci-procenat-zarade/vazeci-procenat-zarade-update.component';
import { VazeciProcenatZaradeModalUpdateComponent } from './vazeci-procenat-zarade/vazeci-procenat-zarade-modal-update.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZbirniDnevnikComponent } from './zbirni-dnevnik/zbirni-dnevnik.component';
import { YtNgFrameworkModule, ModalContainerService, ModalService } from 'yt-ng-framework';
import { YtXChangeRoutingModule } from './yt-xchange-routing.module';
import { ZbirniDnevnikModalUpdateComponent } from './zbirni-dnevnik/zbirni-dnevnik-modal-update.component';
import { ZbirniDnevnikUpdateComponent } from './zbirni-dnevnik/zbirni-dnevnik-update.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { YtXchangeComponent } from './yt-xchange.component';
import { WesternUnionComponent } from './western-union/western-union.component';
import { WesterUnionUpdateComponent } from './western-union/western-union-update.component';
import { WesternUnionModalUpdateComponent } from './western-union/western-union-modal-update.component';
import { PlacanjeRacunaComponent } from './placanje-racuna/placanje-racuna.component';
import { PlacanjeRacunaModalUpdateComponent } from './placanje-racuna/placanje-racuna-modal-update.component';
import { PlacanjeRacunaUpdateComponent } from './placanje-racuna/placanje-racuna-update.component';
import { DokumentComponent } from './dokument/dokument.component';
import { DokumentUpdateComponent } from './dokument/dokument-update.component';
import { DokumentModalUpdateComponent } from './dokument/dokument-modal-update.component';
import { DokumentStavkaUpdateComponent } from './dokument/dokument-stavka-update.component';
import { DokumentStavkaModalUpdateComponent } from './dokument/dokument-stavka-modal-update.component';
import { NetoOtkupniFondComponent } from './neto-otkupni-fond/neto-otkupni-fond.component';
import { VazeciProcenatZaradeComponent } from './vazeci-procenat-zarade/vazeci-procenat-zarade.component';
import { LookupsModule } from '../lookups/lookups.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NedeljniNetoOtkupniFondComponent } from './nedeljni-neto-otkupni-fond/nedeljni-neto-otkupni-fond.component';
import { ZaradaPoMenjacniciComponent } from './zarada-po-menjacnici/zarada-po-menjacnici.component';
import { StanjePoValutamaComponent } from './stanje-po-valutama/stanje-po-valutama.component';
import { DefaultFilter } from '../lookups/default-filter/default-filter.component';



@NgModule({
  imports: [
    // CommonModule
    // , YtNgFrameworkModule
     YtXChangeRoutingModule
     ,LookupsModule
     ,NgbModule
    , TranslateModule
    // , FormsModule
    // , ReactiveFormsModule
  ],
  declarations: [
      ZbirniDnevnikComponent, ZbirniDnevnikModalUpdateComponent, ZbirniDnevnikUpdateComponent
    , YtXchangeComponent
    , WesternUnionComponent, WesternUnionModalUpdateComponent, WesterUnionUpdateComponent
    , PlacanjeRacunaComponent, PlacanjeRacunaModalUpdateComponent, PlacanjeRacunaUpdateComponent
    , DokumentComponent
    , DokumentUpdateComponent
    , DokumentModalUpdateComponent
    , DokumentStavkaUpdateComponent
    , DokumentStavkaModalUpdateComponent
    , NetoOtkupniFondComponent
    , VazeciProcenatZaradeComponent
    , VazeciProcenatZaradeModalUpdateComponent
    , VazeciProcenatZaradeUpdateComponent
    , NedeljniNetoOtkupniFondComponent
    , ZaradaPoMenjacniciComponent, StanjePoValutamaComponent
],
  // entryComponents:[
  //   ZbirniDnevnikUpdateComponent
  //   , ZbirniDnevnikModalUpdateComponent
  //   , WesterUnionUpdateComponent
  //   , WesternUnionModalUpdateComponent
  //   , PlacanjeRacunaUpdateComponent
  //   , PlacanjeRacunaModalUpdateComponent
  //   , DokumentModalUpdateComponent
  //   , DokumentStavkaModalUpdateComponent
  //   , VazeciProcenatZaradeModalUpdateComponent
  //   , VazeciProcenatZaradeUpdateComponent
  //   , DefaultFilter
  // ],
providers:[
  ModalContainerService
  , ModalService
]
})
export class YtXChangeModule { }
